import * as React from "react";
import { Helmet } from "react-helmet-async";
import { Formik } from "formik";
import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import useMediaQuery from "@mui/material/useMediaQuery";
import axios from "axios";
import {
  TableContainer,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Paper,
  Table,
} from "@mui/material";
// @mui
import { Card, Stack, Container, Typography, Box, Button } from "@mui/material";

import { Link } from "react-router-dom";
// hooks
import useSettings from "../../../hooks/useSettings";

// components
import Page from "../../../components/Page";
import { useEffect } from "react";
import { useState } from "react";
import useDetails from "src/hooks/useDetails";
import { use } from "react";

// ----------------------------------------------------------------------

export default function PatientVitalsLog() {
  const { themeStretch } = useSettings();
  const [rows, setRows] = useState([]);
  const [id, setId] = useState("");
  const userDetails = useDetails();
  let p_id = userDetails?.pp_id;
  //console.log(p_id );
  console.log("");

  useEffect(() => {
    axios
      .post(
        "https://ehr.kaizendigital.ai/api/dev3/postvital",
        JSON.stringify({ patient_id: p_id })
      )
      .then((response) => {
        setRows(response.data);
      });
  }, [p_id]);

  const isNonMobile = useMediaQuery("(min-width:600px)");

  const handleFormSubmit = (values) => {
    //console.log(values);
    console.log("");
  };

  const [patientname, setName] = React.useState("");
  const [patientemail, setEmail] = React.useState("");
  const handleChanging = (event) => {
    setName(event.target.value);
  };
  const handleChanged = (event) => {
    setEmail(event.target.value);
  };

  return (
    <>
      <Helmet>
        <title> My Vitals Log | Kaizen Digital </title>
      </Helmet>
      <Page title="Page Two">
        <Container maxWidth={themeStretch ? false : "xl"}>
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
            mb={5}
          >
            <Stack direction="column" spacing={0}>
              <Typography variant="h3" gutterBottom color="primary">
                My Vitals Log
              </Typography>
              <div role="presentation"></div>
            </Stack>
            <Stack direction="row" spacing={2}>
              <Link to="/dashboard/addvitals">
                <Button
                  type="submit"
                  variant="contained"
                  spacing={2}
                  sx={{ color: "white" }}
                >
                  ADD MY VITALS
                </Button>
              </Link>
            </Stack>
          </Stack>

          <h1>
            <Card>
              <Box sx={{ width: "100%" }}>
                <TableContainer component={Paper}>
                  <Table sx={{ minWidth: 650 }} aria-label="simple table">
                    <TableHead>
                      <TableRow>
                        <TableCell align="left">ID</TableCell>
                        <TableCell align="left">Device ID</TableCell>
                        <TableCell align="left">Device Name</TableCell>
                        <TableCell align="left">
                          Heart Rate (Pulse Rate)
                        </TableCell>
                        <TableCell align="left">BP (Blood Pressure)</TableCell>
                        <TableCell align="left">Weight </TableCell>
                        <TableCell align="left">Height </TableCell>
                        <TableCell align="left">Temperature</TableCell>
                        <TableCell align="left">SPO2 </TableCell>
                        <TableCell align="left">Date of Entry</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {rows.map((row) => (
                        <TableRow
                          //  key={row.id}
                          sx={{
                            "&:last-child td, &:last-child th": { border: 0 },
                          }}
                        >
                          <TableCell component="th" scope="row" align="left">
                            {row.patient_id}
                          </TableCell>
                          <TableCell component="th" scope="row" align="left">
                            {row.device_id}
                          </TableCell>
                          <TableCell component="th" scope="row" align="left">
                            {row.device_name}
                          </TableCell>
                          <TableCell component="th" scope="row" align="left">
                            {row.heart_rate}
                          </TableCell>
                          <TableCell component="th" scope="row" align="left">
                            {row.bp}
                          </TableCell>
                          <TableCell component="th" scope="row" align="left">
                            {row.weight}
                          </TableCell>
                          <TableCell component="th" scope="row" align="left">
                            {row.height}
                          </TableCell>
                          <TableCell component="th" scope="row" align="left">
                            {row.temperature}
                          </TableCell>
                          <TableCell component="th" scope="row" align="left">
                            {row.spo2}
                          </TableCell>
                          <TableCell component="th" scope="row" align="left">
                            {row.date_of_joining}
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Box>
            </Card>
          </h1>
        </Container>
      </Page>
    </>
  );
}
